export { default } from './exactProp';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/exactProp/index.js
// module id = 373
// module chunks = 22